var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 3.5h4.4c.865 0 1.423.001 1.848.036.408.033.559.09.633.127a1.5 1.5 0 01.655.656c.038.074.095.225.128.633.035.425.036.983.036 1.848v10.4c0 .865-.001 1.423-.036 1.848-.033.408-.09.559-.127.633a1.5 1.5 0 01-.656.655c-.074.038-.225.095-.633.128-.425.035-.983.036-1.848.036H9.8c-.865 0-1.423-.001-1.848-.036-.408-.033-.559-.09-.633-.127a1.5 1.5 0 01-.656-.656c-.037-.074-.094-.225-.127-.633-.035-.425-.036-.983-.036-1.848V6.8c0-.865.001-1.423.036-1.848.033-.408.09-.559.127-.633a1.5 1.5 0 01.656-.656c.074-.037.225-.094.633-.127C8.377 3.5 8.935 3.5 9.8 3.5zM5 6.8c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C7.28 2 8.12 2 9.8 2h4.4c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311C19 4.28 19 5.12 19 6.8v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311C16.72 22 15.88 22 14.2 22H9.8c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C5 19.72 5 18.88 5 17.2V6.8zM12 19a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "currentColor"
  })));
}

export default SvgPhone;